// Constrói o prototipo com as propriedades padrões.
const getDefaultPrototype = () => ({
  trackBy: 'id',
  label: 'name',
  multiple: true,
  maxHeight: 180,
});

export default function builder(vm, binds) {
  const finalBinds = Object.assign(getDefaultPrototype(), binds);

  if (!Object.prototype.hasOwnProperty.call(finalBinds, 'selectLabel')) {
    finalBinds.selectLabel = vm.$t('multiselect.select');
  }

  if (!Object.prototype.hasOwnProperty.call(finalBinds, 'selectedLabel')) {
    finalBinds.selectedLabel = vm.$t('multiselect.selected');
  }

  if (!Object.prototype.hasOwnProperty.call(finalBinds, 'deselectLabel')) {
    finalBinds.deselectLabel = vm.$t('multiselect.deselect');
  }

  if (!Object.prototype.hasOwnProperty.call(finalBinds, 'placeholder')) {
    finalBinds.placeholder = vm.$t('multiselect.placeholder');
  }

  return finalBinds;
}
